import { render } from "./RecentView.vue?vue&type=template&id=88b864dc"
import script from "./RecentView.vue?vue&type=script&lang=js"
export * from "./RecentView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__